<template>
  <GradientButton
    :title="label"
    :small="true"
    button-size="medium"
    callout=""
    class="ml-2"
    @gradientButtonClicked="$emit('click')"
    @click.native.stop
  />
</template>

<script>
  import GradientButton from '../guest/GradientButton.vue';

  export default {
    name: 'DocumentUploadButton',
    components: { GradientButton },
    props: {
      label: { type: String, default: 'Upload' },
    },
  };
</script>
